import React from 'react';
import {
  Alert,
  CircularProgress,
  Snackbar,
  Typography,
} from '@mui/material';

/**
 * Small bottom banner: “Saving… N / total”.
 * Used by MapWrapper while annotations are saved in the background
 * (move / translate / remove points).
 */
function ParallelProgressSnackbar({
  open,
  running = false,
  severity = 'info',
  message,
  onClose,
}) {
  return (
    <Snackbar
      open={open}
      autoHideDuration={running ? null : 4000}
      onClose={(_, reason) => {
        if (reason === 'clickaway' && running) return;
        onClose?.();
      }}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{ '&.MuiSnackbar-anchorOriginBottomCenter': { bottom: 72 } }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        variant="filled"
        icon={running ? <CircularProgress size={18} color="inherit" /> : undefined}
        sx={{ width: '100%', maxWidth: 480 }}
      >
        <Typography variant="body2">{message}</Typography>
      </Alert>
    </Snackbar>
  );
}

export default ParallelProgressSnackbar;
